import { RefinementCtx, ZodIssueCode } from 'zod'

const createIssue = (key: string, values?: Record<string, unknown>) => ({
  code: ZodIssueCode.custom,
  params: {
    i18n: {
      key: `validator.${key}`,
      values,
    },
  },
})

/**
 * Commonly used as workaround to ensure a string is present and not an empty string.
 * This is needed due to how react handles controlled vs uncontrolled input components.
 */
export const required =
  (values?: Record<string, unknown>) => (val?: string, ctx?: RefinementCtx) => {
    if (!val && ctx) {
      ctx.addIssue(createIssue('required', values))
    }
  }
